import {Component, Vue} from 'vue-property-decorator';
import _ from "lodash";
import * as userService from "@/service/userService";
import * as util from "@/service/util";
import {MomentInput} from "moment";

@Component
export default class BaseComponent extends Vue {

  publicPath = process.env.BASE_URL;

  readonly passwordPattern = /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ `~!@#\$%\^&\*()\-_=+\[\]{}\\|;:'",<.>\/?]).*/.source;
  // readonly personNamePattern = "^[A-Za-z ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸàáạảãâầấậẩẫăằắặẳẵđèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹ]+$";
  readonly phonePattern = /^(0|(\+84))[0-9]{9,10}$/.source;
  readonly usernamePattern = /^[A-Za-z0-9_]*$/.source;

  readonly loadingModalId = "modal-loading";

  userId: number = userService.getCurrentUserId() || null;
  user = userService.getCurrentUser() || null;


  userCheck() {
    return this.user && !this.user.mustChangePassword;
  }


  isUserAdmin(): boolean {
    return ["Admin", "SupperAdmin"].includes(this.user?.role);
  }

  isUserSuperAdmin(): boolean {
    return this.user?.role === "SupperAdmin";
  }

  getUserManagerSaleAreaId(): number {
    if (this.isManager()) {
      return this.user.saleAreaId;
    }
  }

  isManager(): boolean {
    return this.user?.role === "Manager";
  }

  isCustomer(): boolean {
    return this.user?.role === "Customer";
  }

  isCustomerUser(): boolean {
    return this.user?.role === "User";
  }

  isViewUser(): boolean {
    return this.user?.role === "View";
  }

  getUserCustomerId(): number {
    if (this.isCustomer() || this.isCustomerUser()) {
      return this.user.customerId;
    }
  }

  isUserOrAdmin(userId: number) {
    return this.userId === userId || this.isUserAdmin();
  }

  toastErrorOldType(e) {
    const message = e.response?.data?.message || e.message;
    this.$bvToast.toast(message, {
      toaster: "b-toaster-bottom-right",
      title: "Error",
      autoHideDelay: 7500,
      variant: "danger",
      headerClass: "bg-danger text-white"
    });
  }

  toastError(e) {
    const message = e.response?.data?.code || e.code;
    this.$bvToast.toast(this.$t(message).toString(), {
      toaster: "b-toaster-bottom-right",
      title: "Error",
      autoHideDelay: 7500,
      variant: "danger",
      headerClass: "bg-danger text-white"
    });
  }

  toastSuccess(title: string, message: string) {
    return this.$bvToast.toast(message, {
      toaster: "b-toaster-bottom-right",
      title,
      autoHideDelay: 7500,
      variant: "success",
      headerClass: "bg-success text-white"
    });
  }

  toastSuccessDelay(message: string, title?: string, delay?: number) {
    title = title || this.$t("alert").toString();
    if (_.isNil(delay)) delay = 300;

    return setTimeout(() => this.toastSuccess(title, message), delay);
  }

  showLoading() {
    this.$bvModal.show(this.loadingModalId);
  }

  hideLoading() {
    this.$bvModal.hide(this.loadingModalId);
  }

  localDateTimeFormat(value: MomentInput) {
    return util.localDateTimeFormat(value);
  }

  localDateFormat(value: MomentInput) {
    return util.localDateFormat(value);
  }

  localTimeFormat(value: MomentInput) {
    return util.localTimeFormat(value);
  }

  formatCurrencyAmount(value: number) {
    return util.formatCurrencyAmount(value);
  }

  formatUrl(value: string) {
    const domain = this.getURLsFromLocation();
    const startIndex = value.indexOf('/app');
    value = value.substring(startIndex);
    if (value.charAt(0) === '/') {
      value = value.substring(1);
    }
    return domain + value;
  }

  getURLsFromLocation() {
    try {
        const currentURL = new URL(window.location.href);

        // Tạo URL với http
        const httpURL = new URL(`http://${currentURL.host}`);

        // Tạo URL với https
        const httpsURL = new URL(`https://${currentURL.host}`);

        // Kiểm tra xem http có hỗ trợ không
        if (currentURL.protocol === "http:") {
          return httpURL.href; // Trả về URL hiện tại nếu là http
        } else {
            // Trả về URL với https nếu không phải là http
            return httpsURL.href;
        }
    } catch (error) {
        console.error(`Không thể tạo URL từ window.location: ${error}`);
        return null;
    }
}

}
